<app-indicator-mod [indicatorsIds]="selectedDisplay.indicators"></app-indicator-mod>
```
